import PurchaseActivityList from "./PurchaseActivityList";
import PurchaseActivityIcon from "@mui/icons-material/TrendingUp";

const purchasesActivity = {
  list: PurchaseActivityList,
  icon: PurchaseActivityIcon,
};

export default purchasesActivity;
